import { ThresholdQueries } from '../graphql/threshold.queries';
import { apolloClient } from '@/apollo';
import { IActiveDocumentThreshold } from '@/threshold/types/active-document-threshold';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class ThresholdService {
  static async evaluateActiveDocumentThreshold(
    documentId: string
  ): Promise<{
    hasReachedThreshold: boolean;
    threshold: IActiveDocumentThreshold;
  }> {
    const {
      data: {
        evaluateActiveDocumentThreshold: { hasReachedThreshold, threshold },
      },
    } = await apolloClient.query({
      query: ThresholdQueries.EvaluateActiveDocumentThreshold,
      variables: { documentId },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return { hasReachedThreshold, threshold };
  }
  static async getActiveDocumentThreshold(): Promise<IActiveDocumentThreshold> {
    const {
      data: { activeDocumentThreshold },
    } = await apolloClient.query({
      query: ThresholdQueries.GetActiveDocumentThreshold,
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return activeDocumentThreshold;
  }
}
